module.exports = __webpack_public_path__ + "img/waxwinp_waxdaosynths.45d0e43.png";